import { useSessionStore } from '@/src/hooks/use_session_store'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { LuPlusCircle } from 'react-icons/lu'
import { BaseButton, type BaseButtonProps } from './BaseButton'

/** Lucide outline; thin stroke reads lighter than Radix `RxPlusCircled` at small sizes. */
const defaultCreateIcon = <LuPlusCircle size={16} strokeWidth={1.5} />

export const CreateButton = forwardRef<HTMLButtonElement, Partial<BaseButtonProps>>((props, ref) => {
  const { user } = useSessionStore()
  const { t } = useTranslation()
  const { iconLeft, tooltip, isDisabled, variant, ...rest } = props
  return (
    <BaseButton
      ref={ref}
      {...rest}
      variant={variant ?? 'primary'}
      iconLeft={iconLeft ?? defaultCreateIcon}
      tooltip={user?.readonly ? t('readonly_action_disabled') : tooltip}
      isDisabled={user?.readonly || isDisabled}
    />
  )
})
